export var FeedSendStrategy = /*#__PURE__*/function (FeedSendStrategy) {
  FeedSendStrategy["FIXED"] = "FIXED";
  FeedSendStrategy["SUBSCRIBER_TIME_ZONE"] = "SUBSCRIBER_TIME_ZONE";
  FeedSendStrategy["ASAP"] = "ASAP";
  return FeedSendStrategy;
}({});